module.exports = __webpack_public_path__ + "static/assets/33706d0132d6ea0f7c0277446e9ac7c9.svg";